import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Box, Button, Grid2, Typography } from "@mui/material";

const EditOrg = () => {
  const [org, setOrg] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const { orgId } = useParams();
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const updatedValue = e.target.name === "pan" ? e.target.value.toUpperCase() : e.target.value;
    setOrg({ ...org, [e.target.name]: updatedValue });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = org || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const startDate = data.subscriptionStartDate
      ? new Date(data.subscriptionStartDate)
      : null;
    const endDate = data.subscriptionEndDate
      ? new Date(data.subscriptionEndDate)
      : null;

    if (isEmpty(data.orgName)) newErrors.orgName = "Org Name is required";

    if (isEmpty(data.pan)) {
      newErrors.pan = "PAN is required";
    } else if (!panRegex.test(data.pan)) {
      newErrors.pan = "Invalid PAN format (e.g. ABCDE1234F)";
    }

    if (!startDate) {
      newErrors.subscriptionStartDate = "Subscription Start Date is required";
    }

    if (!endDate) {
      newErrors.subscriptionEndDate = "Subscription End Date is required";
    } else if (startDate && endDate <= startDate) {
      newErrors.subscriptionEndDate = "End date must be after start date";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/organization?orgId=${org.orgId}`,
        {
          orgName: org.orgName,
          pan: org.pan,
          subscriptionStartDate: org.subscriptionStartDate,
          subscriptionEndDate: org.subscriptionEndDate,
          adminEmail: null
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      navigate("/superadmin-dashboard");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (orgId !== undefined) {
      const getOrg = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/organization?orgId=${orgId}`,
            { headers: { Authorization: `Bearer ${user.accessToken}` } }
          );
          setOrg(res.data);
        } catch (error) {
          console.log(error);
        }
      };

      getOrg();
    }
  }, []);

  const handleBack = () => {
    navigate("/superadmin-dashboard");
  };

  return (
    <>
      <div className="dashboard-container">
        <Typography variant="h4">Enter Organization Details</Typography>
        <Grid2
          container
          columnSpacing={2}
          sx={{ width: "60%", margin: "auto" }}
          py={5}
        >
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="orgName">Org Name</label>
            <input
              type="text"
              id="orgName"
              name="orgName"
              onChange={handleChange}
              value={org && org.orgName}
              className={`${errors.orgName && "input-error"}`}
            />
            {errors.orgName && <p className="error">{errors.orgName}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="pan">PAN</label>
            <input
              type="text"
              id="pan"
              name="pan"
              onChange={handleChange}
              value={org && org.pan}
              className={`${errors.pan && "input-error"}`}
            />
            {errors.pan && <p className="error">{errors.pan}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="subscriptionStartDate">
              Subscription Start Date
            </label>
            <input
              type="date"
              id="subscriptionStartDate"
              name="subscriptionStartDate"
              onChange={handleChange}
              value={org && org.subscriptionStartDate}
              className={`${errors.subscriptionStartDate && "input-error"}`}
            />
            {errors.subscriptionStartDate && (
              <p className="error">{errors.subscriptionStartDate}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="subscriptionEndDate">Subscription End Date</label>
            <input
              type="date"
              id="subscriptionEndDate"
              name="subscriptionEndDate"
              onChange={handleChange}
              value={org && org.subscriptionEndDate}
              className={`${errors.subscriptionEndDate && "input-error"}`}
            />
            {errors.subscriptionEndDate && (
              <p className="error">{errors.subscriptionEndDate}</p>
            )}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={handleUpdate}>
          Update Organization
        </Button>
      </Box>
    </>
  );
};

export default EditOrg;
